import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Tischbestellung',
    [ORDER_METHODS.PICKUP]: 'Abholung',
    [ORDER_METHODS.DELIVERY]: 'Lieferung',
  },
  errors: {
    draft_validation_failed: 'Bitte vervollständige deine Lieferadresse, bevor du fortfährst.',
  },
};
